import React from 'react';
import { Form } from 'react-bootstrap';

interface SelectOption {
  value: string;
  label: string;
}

interface FilterSelectProps {
  label: string;
  value: string;
  options: SelectOption[];
  onChange: (value: string) => void;
}

export const FilterSelect: React.FC<FilterSelectProps> = ({ label, value, options, onChange }) => {
  return (
    <>
      <Form.Label className="mb-1" style={{ fontSize: '0.75rem', fontWeight: '500', color: '#ccc' }}>
        {label}
      </Form.Label>
      <Form.Select
        size="sm"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{ fontSize: '0.8rem' }}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Form.Select>
    </>
  );
};


